import React from "react";
import PropTypes from "prop-types";
import "./StatsTableHeader.scss";
import arrow from "../../assets/imgs/dropDown-arrow.png";

const StatsTableHeader = ({
  titles,
  sortItems,
  currentSortCategory,
  isDesc
}) => {
  return (
    <div className="stats-table-header">
      {titles.map(title => (
        <span
          key={title}
          className="stats-table-header__item"
          onClick={() => sortItems(title)}
        >
          <span style={{ paddingRight: "5px" }}>{title}</span>
          {currentSortCategory === title && (
            <img
              className="stats-table-header__item__arrow"
              src={arrow}
              alt=""
              style={{ transform: isDesc ? "rotate(180deg)" : "rotate(0deg)" }}
            />
          )}
        </span>
      ))}
    </div>
  );
};

StatsTableHeader.propTypes = {
  titles: PropTypes.array
};

StatsTableHeader.defaultProps = {
  titles: []
};

export default StatsTableHeader;
